import React, { useState } from "react";
import { enqueueSnackbar } from "notistack";
import { FaFileAlt, FaDownload } from "react-icons/fa";
import Button from "../../../components/Button/Button";
import { useStudentSession } from "../context/StudentSessionContext";
import { downloadResult } from "../../../services/StudentPortal/StudentResultService";
import { termOptions } from "../../../utils/helper";
import "./StudentResult.css";

// Matches Figma node 1676:22572 ("Result") — via the student/download-reportcard
// endpoint (switched 2026-10-27 from the earlier static-token result-view
// endpoint, which had no CORS headers). The term dropdown was removed
// 2026-10-27 per design direction (mobile app shows a per-exam list, not a
// manual term picker) — pending the list endpoint, this still lists every
// term from `termOptions` (src/utils/helper.js, same list the staff Report
// Card module uses) as individually downloadable rows rather than one
// dropdown + single button.
const StudentResult = () => {
  const { student } = useStudentSession();
  const [downloadingTerm, setDownloadingTerm] = useState(null);

  const handleDownload = async (term) => {
    const sessionId = student?.student_program?.session_id;
    if (!sessionId) return;

    setDownloadingTerm(term);
    try {
      const response = await downloadResult(sessionId, term);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${student?.id_number || student?.id}-${term}-result.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      enqueueSnackbar("Result downloaded successfully", { variant: "success" });
    } catch (error) {
      // Mirrors the staff Report Card module's own wording for this exact
      // failure mode (the term's result not being published yet).
      enqueueSnackbar("Result not published yet for this term", { variant: "error" });
    } finally {
      setDownloadingTerm(null);
    }
  };

  return (
    <div className="student-result">
      <h2 className="sp-section-title mb-3">Result</h2>

      <div className="student-result-list">
        {termOptions.map((option) => (
          <div className="sp-card student-result-row" key={option.id}>
            <span className="sp-icon-tile">
              <FaFileAlt />
            </span>
            <span className="student-result-row-name">{option.name}</span>
            <Button
              variant="primary"
              icon={<FaDownload />}
              onClick={() => handleDownload(option.id)}
              loading={downloadingTerm === option.id}
              disabled={downloadingTerm !== null && downloadingTerm !== option.id}
            >
              Download
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StudentResult;
